import React from 'react';
import { Alert, Snackbar as MuiSnackbar } from '@mui/material';
import { useBoundStore } from 'store';
import { closeSnackbar } from 'store/Layout';

export const GlobalSnackbar: React.FC = () => {
  const snackbarState = useBoundStore((state) => state.snackbarState);

  return (
    <MuiSnackbar
      open={snackbarState.open}
      autoHideDuration={snackbarState.autoHideDuration}
      onClose={closeSnackbar}
    >
      <Alert onClose={closeSnackbar} severity={snackbarState.severity}>
        {snackbarState.message}
      </Alert>
    </MuiSnackbar>
  );
};